import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import api from '../utils/api';
import { resolveApiBaseURL } from '../utils/apiBase';

export const useAuthStore = create(
  persist(
    (set) => ({
      user: null,
      token: null,
      isAuthenticated: false,

      login: async (username, password) => {
        try {
          console.log('[AuthStore] Attempting login to /auth/login');
          console.log('[AuthStore] API baseURL:', resolveApiBaseURL());
          
          const response = await api.post('/auth/login', { username, password });
          console.log('[AuthStore] Login response received:', {
            status: response.status,
            hasToken: !!response.data.token,
            hasUser: !!response.data.user
          });
          
          const { token, user } = response.data;
          
          set({ token, user, isAuthenticated: true });
          
          // Set token in API client
          api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
          
          console.log('[AuthStore] Login successful, user:', user.username);
          return { success: true };
        } catch (error) {
          console.error('[AuthStore] Login error:', error);
          console.error('[AuthStore] Error details:', {
            message: error.message,
            response: error.response?.data,
            status: error.response?.status,
            url: error.config?.url,
            baseURL: error.config?.baseURL
          });
          
          const data = error.response?.data;
          const noResponse = !!error.request && !error.response;
          const reason =
            data && typeof data === 'object' && data.reason
              ? String(data.reason)
              : '';
          const errorMessage =
            data && typeof data === 'object' && data.error
              ? `${data.error}${reason ? ` (${reason})` : ''}`
              : noResponse
                ? import.meta.env.DEV
                  ? 'Cannot reach the backend. In web\\backend run npm run dev:fresh and confirm "port 3000" in the terminal.'
                  : 'Cannot reach BWOF API. Run RUN_DEPLOY.bat on your PC (nginx must proxy /api to port 3010, not electricalapp on 3000).'
                : 'Login failed';
          
          return {
            success: false,
            error: errorMessage,
            status: error.response?.status,
            details: typeof data === 'object' && data ? data : undefined,
          };
        }
      },

      logout: async () => {
        try {
          await api.post('/auth/logout');
        } catch (error) {
          console.error('Logout error:', error);
        } finally {
          set({ user: null, token: null, isAuthenticated: false });
          delete api.defaults.headers.common['Authorization'];
        }
      },

      setToken: (token) => {
        set({ token, isAuthenticated: !!token });
        if (token) {
          api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        }
      },

      checkAuth: async () => {
        try {
          const response = await api.get('/auth/me', { skipErrorToast: true });
          set({ user: response.data, isAuthenticated: true });
          return true;
        } catch (error) {
          const status = error.response?.status;
          // Only clear session on real auth failure ?? keep session if network is temporarily down
          if (status === 401 || status === 403) {
            set({ user: null, token: null, isAuthenticated: false });
            delete api.defaults.headers.common['Authorization'];
          }
          return false;
        }
      },
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({
        token: state.token,
        user: state.user,
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
);
